import { render } from "./TransactHeader.vue?vue&type=template&id=1e9c9fc8&ts=true"
import script from "./TransactHeader.vue?vue&type=script&lang=ts"
export * from "./TransactHeader.vue?vue&type=script&lang=ts"

import "./TransactHeader.vue?vue&type=style&index=0&id=1e9c9fc8&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/transact/TransactHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e9c9fc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e9c9fc8', __exports__)) {
    api.reload('1e9c9fc8', __exports__)
  }
  
  module.hot.accept("./TransactHeader.vue?vue&type=template&id=1e9c9fc8&ts=true", () => {
    api.rerender('1e9c9fc8', render)
  })

}


export default __exports__